import React from 'react';
import './unauthorized.css';

const Unauthorized = () => {
  return (
    <div
      className="unauthorizedScreen"
    >
      <h1>
        There is no page to display!
      </h1>
    </div>
  );
};

export default Unauthorized;
